// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"O3-z"};